import { segmentTrack, sendUserInfoToAppcues } from '@/utils'

/**
 * The one way the redesigned auth pages turn a backend session answer ({ token, user })
 * into a logged-in SPA: same commits and side effects as the legacy Login.vue success path.
 * Returns the router promise of the final navigation.
 */
export function finishLogin (vm, { token, user }, { event = 'login', eventData = {}, redirect = '' } = {}) {
  const store = vm.$store
  store.commit('setCurrentSubAccount', '')
  store.commit('setJwtToken', { jwt: token })
  store.commit('setUser', user)
  try {
    store.dispatch('fetchGoogleSearchLocations')
  } catch (e) {
    console.log(e)
  }
  try {
    window.profitWellUserEmail = user.email
    if (window.profitwell) window.profitwell('user_email', user.email)
  } catch (e) {
    console.log(e)
  }
  segmentTrack(event, { email: user.email, userID: user.id, ...eventData })
  try {
    sendUserInfoToAppcues(user)
  } catch (e) {
    console.log(e)
  }
  return vm.$router.push(redirect || '/sites')
}

export function trackGoogleSignupConversion () {
  try {
    if (typeof gtag === 'function') {
      gtag('event', 'RegisteredforPOPapp', { event_category: 'registeredapp', event_label: 'sucreg' })
    }
  } catch (e) {
    console.log(e)
  }
}
